import { memo, useCallback, useEffect, useRef } from 'react';
import { Box, Button, Icon, Text } from '@betty/moonlight';
import {
  StackNavigationProp,
  useFocusEffect,
  useNavigation,
} from '@betty/navigation';
import { fetchTransactionHistory } from '../../state';
import { useDispatch } from '@betty/toolkit/state';

function VerifyCard({ selectedTimeStamp }: { selectedTimeStamp: string }) {
  const dispatch = useDispatch();

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const verifyCard = useCallback(() => {
    navigation.navigate('PaymentMethodVerification');
  }, [navigation]);

  const hasMounted = useRef(false);

  const selectedTimeStampRef = useRef(selectedTimeStamp);

  useEffect(() => {
    selectedTimeStampRef.current = selectedTimeStamp;
  }, [selectedTimeStamp]);

  useFocusEffect(
    useCallback(() => {
      if (!hasMounted.current) {
        hasMounted.current = true;
        return;
      }
      const timestamp = selectedTimeStampRef.current;

      if (!timestamp) return;

      dispatch(
        fetchTransactionHistory({
          startDate: timestamp,
          replace: true,
        }),
      );
    }, []),
  );

  return (
    <Box
      borderWidth="border-width-025"
      variant="outline-gradient"
      borderRadius="radius-200"
      gradient="borderAccent"
      padding="space-400"
      gap="space-200"
    >
      <Box flexDirection="row" gap="space-100" alignItems="center">
        <Icon
          name="info"
          width="space-600"
          height="space-600"
          color="darkSurfacePrimary"
        />
        <Text
          variant="body-s-semi"
          color="darkSurfaceTertiary"
          locKey="verifyCardTitle"
          locNS="account"
        />
      </Box>
      <Text
        variant="caption"
        color="darkSurfaceMuted"
        locKey="verifyCardDescription"
        locNS="account"
      />

      <Button
        variant="primary"
        maxWidth="40%"
        size="small"
        locNS="common"
        locKey="verify"
        marginTop="space-200"
        onPress={verifyCard}
      />
    </Box>
  );
}

export default memo(VerifyCard);
